import React from "react";
import styled from "styled-components";

const InfoContainer = styled.div`
  display: flex;
  flex: 2;
  flex-direction: row;
  order: 1;
  .avatar {
    box-sizing: content-box;
    width: 70px;
    height: 70px;
    border: 2px solid #cecece;
    border-radius: 70px;
    overflow: hidden;
    display: block;
  }
  .info {
    display: flex;
    flex-direction: column;
    margin-right: 10px;
    justify-content: space-evenly;
    .name {
      font-size: 0.9rem;
      font-weight: 500;
      color: #333333;
    }
    .class-id {
      font-size: 0.8rem;
      color: #a8a8a8;
    }
  }
`;

function Info({ data, loading, hook }) {
  return (
    <InfoContainer>
      <div
        className="avatar"
        rel="noopener noreferrer"
        target="_blank"
        href={
          (data.PublicUsername || data.TeacherPublicUsername) &&
          `/teacher/${data.PublicUsername || data.TeacherPublicUsername}`
        }
      >
        <img
          src={hook.methods.AvatarSwitcher(data.UserAvatar)}
          alt="#"
          width="70"
          height="70"
          className="image"
        />
      </div>
      <div className="info">
        {data.FirstName ? (
          <div className="name">{`${data.FirstName} ${data.LastName}`}</div>
        ) : null}
        <div className="class-id">{`شناسه درس : ${data.Session?.ID}`}</div>
      </div>
    </InfoContainer>
  );
}

export default Info;
